import MainButton from "../forms/Buttons";
import React, {Component} from "react";
import * as PropTypes from "prop-types";
import classNames from 'classnames';

class SelectButtons extends Component {
    // TODO: Write Doc.
    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);

        this.state = {
            value: undefined,
        };
    }

    componentDidMount() {
        if (this.props.onLoad) {
            const {value} = this.state;
            const {name} = this.props;
            this.props.onLoad(name, value);
        }

        const {options, defaultValue: propsDefaultValue} = this.props;
        let defaultValue = undefined;

        if (this.hasValue(options, propsDefaultValue))
            defaultValue = propsDefaultValue;

        this.handleChange(defaultValue);
    }

    componentWillUnmount() {
        if (this.props.onDestroy) {
            const {name} = this.props;
            this.props.onDestroy(name);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const {options} = nextProps;
        const {value} = this.state;
        const {defaultValue} = this.props;

        if (!this.hasValue(options, value)) {
            if (options.length > 0) {
                if (this.hasValue(options, defaultValue))
                    this.handleChange(defaultValue);
            } else
                this.handleChange(undefined);
        }
    }


    hasValue = (options, value) => options.filter(option => option.value === value).length !== 0;

    render = () => {
        const {split} = this.props;
        const componentClassName = this.getComponentClassName();
        const colorClassName = this.getColorClassName();

        return (
            <div className={classNames("select-buttons", componentClassName, colorClassName, {"select-buttons-split": split})}>
                {this.renderOptions()}
            </div>
        );
    };

    renderOptions = () => {
        const {options} = this.props;
        return options.map(this.renderOption);
    };

    renderOption = (option, index) => {
        const {value} = this.state;
        const {size} = this.props;
        const color = option.value === value ? "toggleActive" : "toggleInactive";

        return (
            <MainButton size={size} color={color} key={index} text={option.label} onClick={(event) => this.handleSelect(event, option)}/>
        );
    };

    handleSelect = (event, option) => {
        this.handleChange(option.value);

        const {onSelect, name} = this.props;
        if (typeof onSelect === 'function')
            onSelect(event, option, name);
    };


    handleChange = (value) => {
        this.setState({
            value: value
        });

        const {onChange, name, options} = this.props;
        if (typeof onChange === 'function') {
            const option = options.filter(option => option.value === value)[0];

            onChange(option);
        }
    };


    getComponentClassName = () => this.props.className;

    getColorClassName = () => this.props.color;

    static propTypes = {
        // String element name
        name: PropTypes.string,
        // Array of options.
        options: PropTypes.array.isRequired,
        // The default value of select.
        defaultValue: PropTypes.string,
        // The size of select, values: sm, md, lg.
        size: PropTypes.string,
        // The handler of select event.
        onSelect: PropTypes.func,
        // Determine if split or not.
        split: PropTypes.bool,
        // The color of component.
        color: PropTypes.string,
    };

    static defaultProps = {
        color: 'primary'
    };
}

export default SelectButtons;
